import React from 'react'
import {
  createTheme,
  DeprecatedThemeOptions as CoreThemeOptions,
  adaptV4Theme,
  ComponentsOverrides as CoreOverrides,
  ComponentsProps as CoreComponentsProps,
} from '@mui/material/styles'
import { CentraTheme } from 'components/styles/variables'
import { createSvgIcon } from '@mui/material/utils'

const MuiCheckboxIcon = createSvgIcon(
  <path
    d="M20 24H4C1.8 24 0 22.2 0 20V4C0 1.8 1.8 0 4 0H20C22.2 0 24 1.8 24 4V20C24 22.2 22.2 24 20 24ZM4 1C2.3 1 1 2.3 1 4V20C1 21.7 2.3 23 4 23H20C21.7 23 23 21.7 23 20V4C23 2.3 21.7 1 20 1H4Z"
    fill="#181A1A"
  />,
  'MuiCheckboxIcon'
)

const MuiCheckboxCheckedIcon = createSvgIcon(
  <>
    <path
      d="M4 0H20C22.2 0 24 1.8 24 4V20C24 22.2 22.2 24 20 24H4C1.8 24 0 22.2 0 20V4C0 1.8 1.8 0 4 0Z"
      fill="#181A1A"
    />
    <path
      d="M9.5 17C9.2 17 9 16.9 8.8 16.7L5.3 13.2C4.9 12.8 4.9 12.2 5.3 11.8C5.7 11.4 6.3 11.4 6.7 11.8L9.5 14.6L16.8 7.3C17.2 6.9 17.8 6.9 18.2 7.3C18.6 7.7 18.6 8.3 18.2 8.7L10.2 16.7C10 16.9 9.8 17 9.5 17Z"
      fill="white"
    />
  </>,
  'MuiCheckboxIcon'
)

interface DeprecatedThemeOptions extends CoreThemeOptions {
  props?: CoreComponentsProps | undefined
}

const overrides: CoreOverrides = {
  MuiTextField: {
    root: {
      padding: 0,
      '& .MuiOutlinedInput-notchedOutline': {
        visibility: 'hidden',
      },
    },
  },
  MuiSkeleton: {
    root: {
      borderRadius: 14,
      backgroundColor: CentraTheme.colors.greySemiLight,
      transform: 'scale(1, 0.75)',

      '& button, & div, & p, & span, & h1, & h2, & h3, & h4, & h5': {
        opacity: 0,
      },
    },
    text: {
      borderRadius: 14,
    },
    rectangular: {
      height: 'auto',
      transform: 'scale(1)',
    },
    circular: {
      height: 'auto',
      transform: 'scale(1)',
      borderRadius: '50%',
    },
  },
  MuiCheckbox: {
    root: {
      '&.Mui-checked': {
        color: CentraTheme.colors.black,
      },
      '& .MuiSvgIcon-root': {
        fontSize: '1.5rem',

        '&.MuiSvgIcon-fontSizeSmall': {
          fontSize: '1rem',
        },
      },
    },
    colorPrimary: {
      color: CentraTheme.colors.greySemiDark,
    },
  },
}

export default function createMyTheme(options: DeprecatedThemeOptions): DeprecatedThemeOptions {
  return createTheme(adaptV4Theme(options))
}

const MuiTheme = createMyTheme({
  ...CentraTheme,
  typography: {
    fontFamily: CentraTheme.fonts.inter,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  props: {
    MuiSkeleton: {
      animation: 'wave',
    },
    MuiCheckbox: {
      icon: <MuiCheckboxIcon />,
      checkedIcon: <MuiCheckboxCheckedIcon />,
    },
  },
  overrides,
})

export { MuiTheme }
